//importing components
import HeadTitle from "../global/HeadTitle";
import { openPop } from "../../utilities/helper";
//importing assets
import Front from "../../Assets/images/front.svg";
import Back from "../../Assets/images/back.svg";
import FullScreen from "../../Assets/icons/full screen.svg";
import { useState } from "react";
import PopContainer from "../../container/pops-container";

export const PersonalPaper = () => {
  const [showId, setShowID] = useState(false);
  const [src, setSrc] = useState("");

  const showPopID = (e) => {
    const img = e.target.previousSibling;
    setSrc(img.src);
    setShowID(true);
    openPop();
  };

  return (
    <div className="personal-paper">
      <div className="flex-between">
        <HeadTitle title=" بطاقة الهوية" />
        <p className="status-btn  status-btn--green">مفعل</p>
      </div>
      <div className="flex-between">
        <div className="personal-paper__side">
          <p className="mb__small">* الصورة الامامية</p>
          <div className="personal-id__box">
            <img src={Front} alt="id " className="personal-id__img" />
            <img
              src={FullScreen}
              alt="full screen icon"
              className="personal-id__fs"
              onClick={showPopID}
            />
          </div>
        </div>
        <div className="personal-paper__side">
          <p className="mb__small">* الصورة الخلفية</p>
          <div className="personal-id__box">
            <img src={Back} alt="id " className="personal-id__img" />
            <img
              src={FullScreen}
              alt="full screen icon"
              className="personal-id__fs"
              onClick={showPopID}
            />
          </div>
        </div>
        {showId && <PopPID active={src} />}
      </div>
    </div>
  );
};

export const PopPID = ({ active }) => {
  return (
    <PopContainer>
      <img src={active} alt="pop id" className="close-pop pic-id" />
    </PopContainer>
  );
};
